import { useQuery } from '@tanstack/react-query';
import { listForItem } from '../api/activity';

export const activityKey = (itemId: string) => ['activity', itemId] as const;

export function useActivity(itemId: string | null, opts: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: itemId ? activityKey(itemId) : ['activity', '_none'],
    queryFn: () => listForItem(itemId!),
    enabled: itemId !== null && opts.enabled !== false,
    staleTime: 30_000,
  });
}
